export const getPicklistBadgeColor = status => {
  switch (status) {
    case 'created':
      return 'secondary';

    case 'receiving':
      return 'primary';

    case 'closed':
      return 'danger';

    default:
      return 'secondary';
  }
};
